import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=91a0f474&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=91a0f474&prod&lang=css"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=91a0f474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a0f474",
  null
  
)

export default component.exports